import { FormControl } from '@software-platforms/design-system-components';

export interface EnvironmentForm {
  name: FormControl;
  domain: FormControl;
}
